var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H7.833c-1.378 0-2.5 1.153-2.5 2.571v.858H4.5C3.121 3.429 2 4.582 2 6v15.429C2 22.847 3.121 24 4.5 24h11.667c1.378 0 2.5-1.154 2.5-2.571v-.858h.833c1.379 0 2.5-1.153 2.5-2.571V2.571C22 1.153 20.879 0 19.5 0M17 21.429a.846.846 0 0 1-.833.857H4.5a.846.846 0 0 1-.833-.857V6c0-.473.373-.857.833-.857h11.667c.46 0 .833.384.833.857zM20.333 18a.846.846 0 0 1-.833.857h-.833V6c0-1.418-1.122-2.571-2.5-2.571H7V2.57c0-.473.374-.857.833-.857H19.5c.46 0 .833.384.833.857z"
  })));
};
export default SvgCopy;